export default {
  subscriptions: true,
  subscriptions_show_team_cta: true,
  chat_failed_messages_indicator: false,
  chat_retry_failed_messages_button: false,
  chat_refetch_on_new_notifications: true,
  settings_show_delete_team_button: true,
};
